module.exports = __webpack_public_path__ + "static/site-1748617940196/img/gocuotas-logo.8979095a.png";